import InputYesNoView from './InputYesNoView';

export default InputYesNoView;
